import React, { useEffect, useState } from "react";
import { ArrowLeft, CheckCircle2, CreditCard, ShieldCheck } from "lucide-react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import api from "../services/api";

const PaymentPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const cycle = Number(searchParams.get("cycle") || 1);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const validCycle = Number.isInteger(cycle) && cycle > 0;

  useEffect(() => {
    let cancelled = false;
    const preparePayment = async () => {
      try {
        const { data: circle } = await api.get(`/tontines/${id}`);
        if (!cancelled) {
          setData({ amount: circle.amount, currency: circle.currency || "eur" });
        }
      } catch (requestError) {
        if (!cancelled) {
          setError(requestError.response?.data?.message || "Unable to prepare payment.");
        }
      }
    };
    preparePayment();
    return () => {
      cancelled = true;
    };
  }, [id]);

  const startHostedCheckout = async () => {
    if (!validCycle) {
      setError("A valid contribution cycle is required.");
      return;
    }
    setCheckoutLoading(true);
    setError("");
    try {
      const { data: session } = await api.post("/payments/checkout-session", {
        tontineId: id,
        cycleNumber: cycle,
      });
      if (!session.url) throw new Error("Stripe did not return a checkout URL. Please try again.");
      window.location.assign(session.url);
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message || "Unable to open secure checkout.");
      setCheckoutLoading(false);
    }
  };

  return (
    <main className="page-shell max-w-2xl">
      <Link to={`/tontines/${id}`} className="mb-5 inline-flex items-center gap-2 text-sm font-semibold text-violet-700"><ArrowLeft size={16} /> Back to circle</Link>
      <section className="payment-shell">
        <div className="mb-7 flex items-start justify-between gap-4"><div><p className="section-kicker">Secure contribution</p><h1 className="mt-2 font-serif text-3xl font-bold text-indigo-950">Complete your payment</h1><p className="mt-2 text-sm text-slate-600">Cycle {cycle}{data ? ` · ${data.amount} ${data.currency.toUpperCase()}` : ""}</p></div><CheckCircle2 className="text-violet-600" size={27} /></div>
        {error && <p className="rounded-xl bg-red-50 p-4 text-sm text-red-700">{error}</p>}
        <p className="mb-5 rounded-xl bg-violet-50 p-4 text-sm text-violet-900">Continue to Stripe&apos;s secure hosted checkout to pay by card. Your card details are handled by Stripe.</p>
        <button className="btn-aurora w-full" onClick={startHostedCheckout} disabled={checkoutLoading || !validCycle}>
          <CreditCard size={17} /> {checkoutLoading ? "Opening secure checkout..." : `Pay${data ? ` ${data.amount} ${data.currency.toUpperCase()}` : ""} securely`}
        </button>
        <p className="mt-4 flex items-center justify-center gap-2 text-xs text-gray-500"><ShieldCheck size={15} className="text-violet-600" /> Secure payment powered by Stripe</p>
      </section>
    </main>
  );
};

export default PaymentPage;
